
import { Ajax, AjaxError, ISupportSpinner } from '../shared/Ajax';

import {ApplicationDocumentModel} from '../models/ApplicationDocumentModel'
import {MilestoneReportDocumentModel} from '../models/MilestoneReportDocumentModel'

export class DocumentReformController extends Ajax {
    constructor() {
        super(window.__emdgBaseUrl, '/api/documentreform');
    }
    
        getDocuments(owner:ISupportSpinner, applicationId:string, userId:string, success:{(res:ApplicationDocumentModel[]):any}, error?:AjaxError) {
    super._call('get', '', owner, {applicationId:applicationId,userId:userId}, null, success, error)
}

        getMilestoneReportDocuments(owner:ISupportSpinner, applicationId:string, userId:string, success:{(res:MilestoneReportDocumentModel[]):any}, error?:AjaxError) {
    super._call('get', '', owner, {applicationId:applicationId,userId:userId}, null, success, error)
}

        upload(owner:ISupportSpinner, applicationId:string, code:string, folder:string, multiple:boolean, files:any[], success:{(res:ApplicationDocumentModel[]):any}, error?:AjaxError) {
    super._call('post', 'Upload', owner, {applicationId:applicationId,code:code,folder:folder,multiple:multiple}, files, success, error)
}

        delete(owner:ISupportSpinner, applicationId:string, blobID:string, success:{(res:ApplicationDocumentModel[]):any}, error?:AjaxError) {
    super._call('delete', 'Delete', owner, {applicationId:applicationId,blobID:blobID}, null, success, error)
}

        deleteMilestoneReport(owner:ISupportSpinner, applicationId:string, blobID:string, success:{(res:MilestoneReportDocumentModel[]):any}, error?:AjaxError) {
    super._call('delete', 'DeleteMilestoneReport', owner, {applicationId:applicationId,blobID:blobID}, null, success, error)
}

        download(owner:ISupportSpinner, applicationId:string, blobID:string, success:{():any}, error?:AjaxError) {
    super._call('get', 'download', owner, {applicationId:applicationId,blobID:blobID}, null, success, error)
}

        downloadMilestoneReport(owner:ISupportSpinner, applicationId:string, blobID:string, success:{():any}, error?:AjaxError) {
    super._call('get', 'DownloadMilestoneReport', owner, {applicationId:applicationId,blobID:blobID}, null, success, error)
}

        downloadAgreement(owner:ISupportSpinner, claimIdentifier:string, success:{():any}, error?:AjaxError) {
    super._call('get', 'Downloadagreement', owner, {claimIdentifier:claimIdentifier}, null, success, error)
}

        uploadMilestoneReportDocuments(owner:ISupportSpinner, applicationId:string, code:string, parentFolder:string, folder:string, multiple:boolean, files:any[], success:{(res:MilestoneReportDocumentModel[]):any}, error?:AjaxError) {
    super._call('post', 'UploadMilestoneReportDocuments', owner, {applicationId:applicationId,code:code,parentFolder:parentFolder,folder:folder,multiple:multiple}, files, success, error)
}
}
